import { Component, OnInit, Input } from '@angular/core';
import { RefreshService } from './refresh.service';
import { isDefined } from '../commons';

@Component({
  selector: 'app-refresh',
  templateUrl: './refresh.component.html',
  styleUrls: ['./refresh.component.scss']
})
export class RefreshComponent implements OnInit {

  @Input() showTextTime: number;

  constructor(private readonly service: RefreshService) { }

  ngOnInit() {}

  get show(): boolean {
    return !isDefined(this.showTextTime) || this.busy || this.countdown <= this.showTextTime;
  }

  get busy(): boolean {
    return this.service.busy;
  }

  get countdown(): number {
    return this.service.countdown;
  }

  get paused(): boolean {
    return this.service.isPaused;
  }

  toggle() {
    if (this.service.isPaused) {
      this.service.reactivate();
    } else {
      this.service.deactivate();
    }
    return false;
  }
}
